<template>
<div class="chapter">
<div class="inner_page">
<h1 class="book-title"><a id="page_3"></a><span class="small1">THE</span><br/>WORLD INSIDE</h1>
<p class="author">Robert Silverberg</p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="5%"/>
<col width="65%"/>
<col width="35%"/>
</colgroup><tbody><tr>
<td valign="top"><p class="editor"><img alt="Images" src="images/pub.jpg"/></p></td>
<td valign="top"><p class="editor1">A TOM DOHERTY ASSOCIATES BOOK<br/>NEW YORK                                                 </p></td>
<td valign="top"> </td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?421c0c2f